export enum CIRContentTypes {
  IFRAME,
  MANAGED,
  STATIC
}
